require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./cohort-i-mentors.json") })
        }
      }, "path---cohort-i-mentors");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---cohort-i-mentors!./.cache/json/cohort-i-mentors.json
// module id = 627
// module chunks = 231608221292675